var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { "justify-center": "", row: "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            fullscreen: "",
            "hide-overlay": "",
            persistent: "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivAsignacion" } },
            [
              _c("CabeceraModal", {
                attrs: {
                  titulo:
                    "Detalle Alta de Servicio CRM " +
                    (_vm.NombreAlta ? _vm.NombreAlta : "")
                },
                on: { cerrar: _vm.handleCerrar }
              }),
              _c(
                "v-card",
                { attrs: { flat: "", height: "55px" } },
                [
                  _c(
                    "v-bottom-nav",
                    {
                      attrs: {
                        active: _vm.pasos.informacionGeneral.step,
                        value: true,
                        absolute: "",
                        color: "transparent"
                      },
                      on: {
                        "update:active": function($event) {
                          return _vm.$set(
                            _vm.pasos.informacionGeneral,
                            "step",
                            $event
                          )
                        }
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.pasos.informacionGeneral.visible,
                              expression: "pasos.informacionGeneral.visible"
                            }
                          ],
                          attrs: {
                            value: _vm.pasos.informacionGeneral.step,
                            color: "primary",
                            flat: ""
                          },
                          on: { click: _vm.handleInfoGeneral }
                        },
                        [
                          _c("span", [_vm._v("Detalle Asignación")]),
                          _c("v-icon", [_vm._v("info")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showInfo,
                      expression: "showInfo"
                    }
                  ],
                  staticClass: "cardnew",
                  attrs: { align: "center" }
                },
                [
                  _c("br"),
                  _c("v-card", { staticClass: "rounded-card flex sm10 md10" }, [
                    _c(
                      "div",
                      { staticClass: "flex sm10 md10" },
                      [
                        _c(
                          "v-container",
                          { attrs: { "grid-list-md": "" } },
                          [
                            _c(
                              "v-toolbar",
                              [
                                _c(
                                  "v-tabs",
                                  {
                                    attrs: { centered: "" },
                                    model: {
                                      value: _vm.tabs,
                                      callback: function($$v) {
                                        _vm.tabs = $$v
                                      },
                                      expression: "tabs"
                                    }
                                  },
                                  [
                                    _c("v-tabs-slider", {
                                      attrs: { color: "yellow" }
                                    }),
                                    _c("v-tab", [
                                      _vm._v("Equipos y Perifericos")
                                    ]),
                                    _c("v-tab", [
                                      _vm._v("Ordenes de Servicio")
                                    ]),
                                    _c("v-tab", [
                                      _vm._v("Actividad de Preparación")
                                    ]),
                                    _c("v-tab", [_vm._v("Activos")]),
                                    _c("v-tab", [_vm._v("Actividades")]),
                                    _c("v-tab", [
                                      _vm._v("Actividad de Despacho")
                                    ]),
                                    _c("v-tab", [_vm._v("Detalle Venta")])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "v-tabs-items",
                              {
                                model: {
                                  value: _vm.tabs,
                                  callback: function($$v) {
                                    _vm.tabs = $$v
                                  },
                                  expression: "tabs"
                                }
                              },
                              [
                                _c(
                                  "v-tab-item",
                                  [
                                    _c(
                                      "v-card",
                                      { attrs: { flat: "" } },
                                      [
                                        _c("EquiposyPerifericosCrm", {
                                          attrs: {
                                            AltaCrm_Seleccionada:
                                              _vm.Alta_Seleccionada
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-tab-item",
                                  [
                                    _c(
                                      "v-card",
                                      { attrs: { flat: "" } },
                                      [
                                        _c("OrdenesServicio", {
                                          attrs: { NombreAlta: _vm.NombreAlta }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-tab-item",
                                  [
                                    _c(
                                      "v-card",
                                      { attrs: { flat: "" } },
                                      [
                                        _c("ActividadPreparacion", {
                                          attrs: {
                                            AltaCrm_Seleccionada:
                                              _vm.Alta_Seleccionada
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-tab-item",
                                  [
                                    _c(
                                      "v-card",
                                      { attrs: { flat: "" } },
                                      [
                                        _c("Activos", {
                                          attrs: {
                                            AltaCrm_Seleccionada:
                                              _vm.Alta_Seleccionada
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-tab-item",
                                  [
                                    _c(
                                      "v-card",
                                      { attrs: { flat: "" } },
                                      [
                                        _c("Actividades", {
                                          attrs: {
                                            AltaCrm_Seleccionada:
                                              _vm.Alta_Seleccionada
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-tab-item",
                                  [
                                    _c(
                                      "v-card",
                                      { attrs: { flat: "" } },
                                      [
                                        _c("ActividadDespacho", {
                                          attrs: {
                                            AltaCrm_Seleccionada:
                                              _vm.Alta_Seleccionada
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-tab-item",
                                  [
                                    _c(
                                      "v-card",
                                      { attrs: { flat: "" } },
                                      [
                                        _c("DetalleVenta", {
                                          attrs: {
                                            AltaCrm_Seleccionada:
                                              _vm.Alta_Seleccionada
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }